//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import Button from 'react-bootstrap/Button';

import { useAuth } from './BasicAuth';
import * as choiceApi from '../api/choice';

// import choiceBanner from './../assets/images/full-name-transparent.png';
import './BasicAuthUI.css';

export function SignOutButton ({
    title = 'Sign Out'
}) { 
    const auth = useAuth();

    const onClick = async () => {
        await choiceApi.logout();
        auth.signout(() => null);
    }


    return(
        <Button variant="outline-primary" className="sign-out-btn" onClick={onClick}>{title}</Button>
    )
}

